<template>
  <div>
    <v-tabs
      v-model="getActiveTab"
      show-arrows
      color="primary"
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.icon"
      >
        <v-icon
          size="20"
          class="me-3"
        >
          {{ tab.icon }}
        </v-icon>
        <span>{{ tab.title }}</span>
      </v-tab>
    </v-tabs>

    <v-tabs-items
      v-model="getActiveTab"
      class="mt-5"
    >
      <v-tab-item>
        <TabGuests
          v-if="getActiveTab === 0"
          :event-id="eventId"
        />
      </v-tab-item>

      <v-tab-item>
        Insights
      </v-tab-item>
      <v-tab-item>
        Audience
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mdiAccountOutline } from '@mdi/js';
import { getCurrentInstance, ref, computed } from '@vue/composition-api';
import TabGuests from './Tabs/TabGuests.vue';

export default {
  name: 'P1',
  components: { TabGuests },

  setup() {
    const vm = getCurrentInstance().proxy;

    // State

    const tabs = ref([
      { icon: mdiAccountOutline, title: 'Guests', slug: 'guests' },

      // { title: 'Tonton', slug: 'tonton' },
    ]);

    const { eventId } = vm.$route.params;

    // Tabs
    const getActiveTab = computed({
      get() {
        // const { activeTab } = vm.$route.params;
        // console.log('d', d);

        return 0;
      },
      set(newValue) {
        // set something
        console.log('newValue', newValue);
      },
    });

    // Return

    return {
      // State
      tabs,
      eventId,

      // Computed
      getActiveTab,
    };
  },
};
</script>
